<template>
  <div class="tags-nav">
    <!--关闭所有和其他按钮 start-->
    <div class="close-con">
      <Dropdown transfer style="margin-top:7px;" @on-click="handleClosePageTag">
        <Button size="small" type="text">
          <Icon :size="18" type="ios-close-circle-outline" />
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="close_all">关闭所有</DropdownItem>
          <DropdownItem name="close_others">关闭其他</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <!--右键点击tag显示关闭其他或所有-->
    <ul v-show="visible" :style="{left: contextMenuLeft + 'px', top: contextMenuTop + 'px'}" class="contextmenu">
      <li @click="handleClosePageTag('close_all')">关闭所有</li>
      <li @click="handleClosePageTag('close_others')">关闭其他</li>
    </ul>
    <!--关闭所有和其他按钮 end-->

    <!--菜单栏左右滑动 start-->
    <div class="btn-con left-btn">
      <Button type="text" @click="handleScroll(240)">
        <Icon :size="18" type="ios-arrow-back" />
      </Button>
    </div>
    <div class="btn-con right-btn">
      <Button type="text" @click="handleScroll(-240)">
        <Icon :size="18" type="ios-arrow-forward" />
      </Button>
    </div>
    <!--菜单栏左右滑动 start-->

    <!--菜单栏 start-->
    <div class="scroll-outer" ref="scrollOuter" @DOMMouseScroll="handleMouseScroll" @mousewheel="handleMouseScroll">
      <div ref="scrollBody" class="scroll-body" :style="{left: tagBodyLeft + 'px'}">
        <transition-group name="taglist-moving-animation">
          <Tag
            type="dot"
            v-for="(item, index) in list"
            ref="tagsPageOpened"
            :key="`tag-nav-${index}`"
            :name="item && item.name ? item.name : ''"
            :data-route-item="item"
            @on-close="handleClose(item)"
            @click.native="handleClick(item)"
            :closable="item.name !== 'home'"
            :color="isCurrentTag(item) ? 'primary' : 'default'"
            @contextmenu.prevent.native="contextMenu(item, $event)"
          >{{ getTitle(item) }}</Tag>
        </transition-group>
      </div>
    </div>
    <!--菜单栏 end-->

  </div>
</template>

<script>
import layoutMixin from './layout-mixin'
import { routeEqual } from "@/lib/util";

export default {
  name: 'TagsNav',
  mixins: [layoutMixin],
  props: {
    value: Object,
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      tagBodyLeft: 0,        //菜单栏离左侧的偏移量
      rightOffset: 40,
      outerPadding: 4,
      contextMenuLeft: 0,   //右击tag菜单标签时显示关闭所有和其他菜单的 左侧偏移量
      contextMenuTop: 0,    //右击tag菜单标签时显示关闭所有和其他菜单的 顶部偏移量
      visible: false,       //是否显示关闭所有和其他
    }
  },
  computed: {

  },
  methods: {
    /**
     * 打开页面菜单栏 鼠标滚轮 上下滚动
      firefox使用DOMMouseScroll,其他浏览器使用mousewheel
     firefox使用detail:值为下滚3上滚-3,其他浏览器使用wheelDelta:值为下滚-120上滚120
     **/
    handleMouseScroll (e) {
      var type = e.type
      let delta = 0
      if (type === 'DOMMouseScroll' || type === 'mousewheel') {
        delta = (e.wheelDelta) ? e.wheelDelta : -(e.detail || 0) * 40
      }
      this.handleScroll(delta)
    },
    //计算tag菜单栏偏移量
    handleScroll (offset) {
      const outerWidth = this.$refs.scrollOuter.offsetWidth
      const bodyWidth = this.$refs.scrollBody.offsetWidth
      if (offset > 0) {
        this.tagBodyLeft = Math.min(0, this.tagBodyLeft + offset)
      } else {
        if (outerWidth < bodyWidth) {
          if (this.tagBodyLeft < -(bodyWidth - outerWidth)) {
            // this.tagBodyLeft = this.tagBodyLeft
          } else {
            this.tagBodyLeft = Math.max(this.tagBodyLeft + offset, outerWidth - bodyWidth)
          }
        } else {
          this.tagBodyLeft = 0
        }
      }
    },
    //关闭某个标签1
    handleClose (closeRoute) {
      this.$store.dispatch('app/changeOpenedPage',{route:closeRoute,type:'close',isCurrent:this.isCurrentTag(closeRoute)})
    },
    //关闭其他或所有
    handleClosePageTag(type){
      const { name, params, query, meta } = this.$route
      this.$store.dispatch('app/closeOpenedPage',{ type:type, currentRoute:{ name, params, query, meta }} )
      setTimeout(() => {
        this.getTagElementByRoute(this.$route)
      }, 100)
    },
    handleClick (item) {
      this.$commonFun.jumpTo('',item.name)
    },
    isCurrentTag (route) {
      return routeEqual(this.$route, route)
    },
    //页面切换时，移动到对应标签
    moveToView (tag) {
      const outerWidth = this.$refs.scrollOuter.offsetWidth
      const bodyWidth = this.$refs.scrollBody.offsetWidth
      if (bodyWidth < outerWidth) {
        this.tagBodyLeft = 0
      } else if (tag.offsetLeft < -this.tagBodyLeft) {
        // 标签在可视区域左侧
        this.tagBodyLeft = -tag.offsetLeft + this.outerPadding
      } else if (tag.offsetLeft > -this.tagBodyLeft && tag.offsetLeft + tag.offsetWidth < -this.tagBodyLeft + outerWidth) {
        // 标签在可视区域
        this.tagBodyLeft = Math.min(0, outerWidth - tag.offsetWidth - tag.offsetLeft - this.outerPadding)
      } else {
        // 标签在可视区域右侧
        this.tagBodyLeft = -(tag.offsetLeft - (outerWidth - this.outerPadding - tag.offsetWidth))
      }
    },
    //根据路由获取要跳转的标签元素
    getTagElementByRoute (route) {
      this.$nextTick(() => {
        this.refsTag = this.$refs.tagsPageOpened
        this.refsTag.forEach((item, index) => {
          if (routeEqual(route, item.$attrs['data-route-item'])) {
            let tag = this.refsTag[index].$el
            this.moveToView(tag)
          }
        })
      })
    },
    //鼠标右键点击tag显示关闭其他或所有菜单
    contextMenu (item, e) {
      if (item.name === this.$config.HOME_PAGE) {
        return
      }
      this.visible = true
      const offsetLeft = this.$el.getBoundingClientRect().left
      this.contextMenuLeft = e.clientX - offsetLeft + 10
      this.contextMenuTop = e.clientY - 64
    },
    closeMenu () {
      this.visible = false
    }
  },
  watch: {
    '$route' (to) {
      this.getTagElementByRoute(to)
    },
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.getTagElementByRoute(this.$route)
    }, 200)
  }
}
</script>

<style lang="less">
@import './tags-nav.less';
</style>
